import { LocalDateTime } from "@js-joda/core";
import { Zoekresultaat } from "../../../.generated/hdndossier/hdndossiertypes";
import {
  getNaamPersoon,
  mapAanleidingen2ReadableString,
  mapGeboorteData,
  mapKlantNamen,
  mapStatus2ReadableString
} from "../../infra/map-zoekscherm";
import {
  ZoekenAdviesDossierType,
  ZoekResultaatType,
  ZoekenHdnDossierSamenvattingType
} from "../../infra/zoekscherm-schema";

let currentVestigingen: Record<string, boolean> = {};

export const mapZoekresultaten = (resultaat: Zoekresultaat[]): ZoekResultaatType[] => {
  currentVestigingen = {};

  const mapAdviesDossiers = (res: Zoekresultaat): ZoekenAdviesDossierType[] => {
    const mappedDossiers = (res.adviesdossiers || []).map(
      (ad): ZoekenAdviesDossierType => {
        return {
          aanleiding: ad.aanleiding ? mapAanleidingen2ReadableString[ad.aanleiding] : null,
          klantdossierId: res.klantdossierId,
          adviesdossierId: ad.adviesdossierId,
          geboorteData: res.aanvrager1 ? res.aanvrager1.geboortedatum?.substr(0, 10) || "" : null,
          postcode: res.postcode || null,
          vestiging: res.naamVestiging,
          vestigingId: res.vestigingId,
          woonplaats: res.woonplaats || null,
          laatstBewerktDatum: ad.laatstBewerktDatum || null,
          laatstBewerktTijd: ad.laatstBewerktTijd || null,
          omschrijving: ad.omschrijving || "",
          status: mapStatus2ReadableString[ad.status],
          hdnDossierId: res.hdnDossiers?.find(hdn => hdn.adviesdossierId === ad.adviesdossierId)?.hdnDossierId || null
        };
      }
    );

    return mappedDossiers;
  };

  const mapHdnDossierSamenvattingen = (res: Zoekresultaat): ZoekenHdnDossierSamenvattingType[] => {
    const mappedDossiers = (res.hdnDossiers || []).map(
      (ad): ZoekenHdnDossierSamenvattingType => {
        return {
          aanvraagVersie: ad.aanvraagVersie,
          adviesOmschrijving: ad.adviesOmschrijving,
          adviesdossierId: ad.adviesdossierId,
          hdnDossierId: ad.hdnDossierId,
          klantNaam: ad.klantNaam,
          laatstOntvangenBericht: ad.laatstOntvangenBericht,
          soortAanvraag: ad.soortAanvraag,
          startDatum: ad.startDatum,
          status: ad.status,
          adviseur: ad.adviseur,
          partijnaam: ad.partijnaam,
          product: ad.product
        };
      }
    );

    return mappedDossiers;
  };

  return resultaat.map(
    (res): ZoekResultaatType => {
      res.naamVestiging && !currentVestigingen[res.naamVestiging] && (currentVestigingen[res.naamVestiging] = true);
      return {
        klantdossierId: res.klantdossierId,
        laatstGeopend:
          res.laatstGeopendDatum && res.laatstGeopendTijd
            ? LocalDateTime.parse(`${res.laatstGeopendDatum.substring(0, 10)}T${res.laatstGeopendTijd}`)
            : null,
        aantalDossiers: res.aantalHdnDossiers,
        adviseur: getNaamPersoon(res.adviseur),
        adviseurId: res.adviseur?.adviseurId ?? null,
        klant: res.aanvrager1 ? mapKlantNamen(res.aanvrager1, res.aanvrager2) : "",
        vestiging: res.naamVestiging || "",
        adviesDossiers: mapAdviesDossiers(res),
        hdnDossiers: mapHdnDossierSamenvattingen(res),
        naamAanvrager: getNaamPersoon(res.aanvrager1),
        geboorteData: res.aanvrager1 ? mapGeboorteData(res.aanvrager1, res.aanvrager2) : [],
        postcode: res.postcode,
        woonplaats: res.woonplaats,
        vestigingId: res.vestigingId,
        naamPartner:
          res.aanvrager2?.achternaam || res.aanvrager2?.voornamen
            ? getNaamPersoon(res.aanvrager2)
            : res.aanvrager2?.geboortedatum
            ? "Aanvrager\xa02"
            : ""
      };
    }
  );
};

export const getCurrentVestigingen = (): string[] => {
  return Object.keys(currentVestigingen);
};
